import CreateFirstQuery from './CreateFirstQuery';

export default CreateFirstQuery;
